import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid2";
import React, { ReactNode } from "react";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import ISalesProduct from "@/interfaces/sales-product.interfaces";

interface HeaderProps {
  children: ReactNode;
  salesProduct: ISalesProduct;
}

const Header = ({ children, salesProduct }: HeaderProps) => {
  return (
    <>
      <MDBox
        height="40vh"
        borderRadius="xl"
        m={2}
        pt={2}
        variant="gradient"
        bgColor="dark"
        coloredShadow="dark"
        textAlign="center"
        display={"flex"}
        justifyContent={"center"}
        flexDirection={"column"}
      >
        <Grid container spacing={3} justifyContent="center" sx={{ py: 22, textAlign: "center" }}>
          <Grid size={{ xs: 11, lg: 5 }}>
            <MDBox mb={1}>
              <MDTypography variant="h2" color="white" fontWeight="bold">
                {salesProduct.name}
              </MDTypography>
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="body2" color="white" fontWeight="light">
                {salesProduct.description}
              </MDTypography>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <Grid container sx={{ px: 6, my: 8 }}>
        <Grid size={{ xs: 11, lg: 12 }}>
          <Card sx={{ mt: -16, p: 2 }}>{children}</Card>
        </Grid>
      </Grid>
    </>
  );
};

export default Header;
